import styled from 'styled-components';

import { Link } from '../Link/Link';

export const Root = styled.div`
  display: flex;
  align-items: center;

  @media (width < 1024px) {
    padding: 24px;
  }

  @media (width >= 1024px) {
    justify-content: center;
    padding: 72px 32px;
  }

  --accent-color: ${(p) => p.$accentColor};
`;

export const Content = styled.div`
  display: flex;

  @media (width < 1024px) {
    flex-direction: column;
    gap: 22px;
  }

  @media (width >= 1024px) {
    gap: 118px;

    &.--reverse {
      flex-direction: row-reverse;
    }
  }
`;

export const ImageContainer = styled.div`
  flex-shrink: 0;

  @media (width < 1024px) {
    width: 100%;
    height: 342px;

    img {
      height: 100%;
    }
  }

  @media (width >= 1024px) {
    width: 500px;
    height: 500px;

    img {
      width: 100%;
    }
  }
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;

  @media (width >= 1024px) {
    justify-content: center;
    max-width: 500px;
  }
`;

export const Title = styled.h2`
  font-size: 40px;
  font-weight: 700;
  line-height: 42px;
`;

export const Desc = styled.span`
  font-size: 17px;
  line-height: 25px;
  letter-spacing: 0.17px;
`;

export const Cta = styled(Link)`
  display: flex;
  align-items: center;
  gap: 7px;
  width: fit-content;
  height: 32px;
  padding: 0 12px 0 20px;
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  text-transform: uppercase;
  border: 0 none;
  border-radius: 16px;
  transition: all 150ms;
`;

export const List = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
  font-size: 17px;
  line-height: 25px;
  letter-spacing: 0.17px;
  list-style: none;
  padding-left: 0;

  li {
    position: relative;
    padding-left: 20px;

    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 8px;
      width: 10px;
      height: 10px;
      background-color: var(--accent-color);
      border-radius: 50%;
    }
  }
`;
